import { render, staticRenderFns } from "./TagsSearchPopover.vue?vue&type=template&id=ceafcaa4"
import script from "./TagsSearchPopover.vue?vue&type=script&lang=js"
export * from "./TagsSearchPopover.vue?vue&type=script&lang=js"
import style0 from "./TagsSearchPopover.vue?vue&type=style&index=0&id=ceafcaa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports